var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"addFile"},[(_vm.text)?[_c('p',[_vm._v("\n    "+_vm._s(_vm.text)+"\n    ")])]:[_c('i',{staticClass:"el-icon-plus"})]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }